import React from "react";

export default function Contact() {
  return (
    <section className="page-container">
      <h2>Contact Us</h2>
      <p>📍 18160 Cottonwood Rd PMB 534, Sunriver, OR 97707</p>
      <p>📞 (404) 491‑1355</p>
      <p>📧 support@berkinson.com</p>
    </section>
  );
}
